import {
  LoadMetadataSpecQuery,
  LoadMetadataSpecMsg,
  PropInfo,
  LoadMetadataSpecResponse
} from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import StringUtil from '../../util/StringUtil';
import HashMap from '../../protocol/HashMap';
import Store from '../../store/Store';
import { PROP_NAME_TO_PROP_INFO, GROUP_CODE_TO_GROUP_INFO } from '../../store/Constants';
import t from '../../i18n/I18n';
import MetadataUtil from '../../util/MetadataUtil';
import AuthenticationController from '../../controllers/AuthenticationController';

export default class MetadataSpec {
  constructor(onlyEditableProps = false, skipId2InfoMap = false, collectionId = 0) {
    this.onlyEditableProps = onlyEditableProps;
    this.skipId2InfoMap = skipId2InfoMap;
    this.collectionId = collectionId;
  }

  generatePropInfo = (allowMultiple: boolean, editable: boolean, groupCode: string, key: string) => {
    return new PropInfo()
      .setAllowMultiple(allowMultiple)
      .setEditable(editable)
      .setGroupCode(groupCode)
      .setKey(key)
      .setMetadataFieldEnum('none')
      .setPossibleValues([])
      .setUserCanType('string');
  };

  run() {
    let assetIdPropInfo = this.generatePropInfo(false, false, MetadataUtil.FIPR_KEY, t(MetadataUtil.ASSET_ID_KEY));

    let fileSizePropInfo = this.generatePropInfo(false, false, MetadataUtil.FIPR_KEY, t(MetadataUtil.ASSET_SIZE_KEY));

    let authorPropInfo = this.generatePropInfo(false, false, null, 'author');
    let versionPropInfo = this.generatePropInfo(false, false, null, 'versions');
    let repoRevisionPropInfo = this.generatePropInfo(false, false, null, 'repo revision');

    return new Promise((onSuccess, onFailure) => {
      const query = new LoadMetadataSpecQuery();
      const msg = new LoadMetadataSpecMsg();

      msg.setSkipId2PropMap(this.skipId2InfoMap);
      msg.setIncludeEditablePropsList(this.onlyEditableProps);
      msg.setCollectionId(this.collectionId);

      query.message = msg;
      query.run().then(
        (resp: LoadMetadataSpecResponse) => {
          if (!this.skipId2InfoMap) {
            window.gs.propName2PropInfoMap = resp.getPropId2InfoMap();
            window.gs.propName2PropInfoMap.put(MetadataUtil.FIPR_ASSET_ID, assetIdPropInfo);
            window.gs.propName2PropInfoMap.put(MetadataUtil.FIRP_ASSET_SIZE, fileSizePropInfo);
            window.gs.propName2PropInfoMap.put(authorPropInfo.getKey(), authorPropInfo);
            window.gs.propName2PropInfoMap.put(versionPropInfo.getKey(), versionPropInfo);
            window.gs.propName2PropInfoMap.put(repoRevisionPropInfo.getKey(), repoRevisionPropInfo);
            window.gs.groupCode2GroupInfoMap = resp.getGroupCode2GroupInfo();
            AuthenticationController.removeCorruptViewProps();
            Store.put(PROP_NAME_TO_PROP_INFO, resp.getPropId2InfoMap());
            Store.put(GROUP_CODE_TO_GROUP_INFO, resp.getGroupCode2GroupInfo());
          }
          if (this.onlyEditableProps) window.gs.editableMetadataProps = resp.getEditableProps();
          window.gs.globalMetadataRestrictPattern = StringUtil.isEmpty(resp.getGlobalRestrictPattern())
            ? undefined
            : resp.getGlobalRestrictPattern();
          onSuccess(resp);
        },
        (failedResp) => {
          //ErrorHandler.handleError(failedResp, t('LOAD_METADATA_SPEC_ERROR'));
          onFailure(failedResp);
        }
      );
    });
  }
}
